var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "progress" }, [
    _c(
      "div",
      { staticClass: "step-list" },
      [
        _vm.apply
          ? [
              _c(
                "ul",
                _vm._l(_vm.apply, function (item, index) {
                  return _c("li", { key: index }, [
                    item.status == 1
                      ? _c("div", { staticClass: "step-time" }, [
                          _vm._v("提交审核 "),
                        ])
                      : _c("div", { staticClass: "step-time" }, [
                          _vm._v(" 财务主管/财务经理审核 "),
                        ]),
                    _vm.type === "shenheStep"
                      ? _c(
                          "div",
                          {
                            class: [
                              { "success-pass": item.status == 2 },
                              { "danger-spot": item.status == 3 },
                              "step-content",
                            ],
                          },
                          [
                            _c("div", { staticClass: "reviewer" }, [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    item.status == 1 ? "提交审核人" : "审核人"
                                  ) +
                                    "：" +
                                    _vm._s(item.userName)
                                ),
                              ]),
                              item.status == 1
                                ? _c("span", { staticClass: "info" }, [
                                    _vm._v("已提交"),
                                  ])
                                : _vm._e(),
                              item.status == 2
                                ? _c("span", { staticClass: "success" }, [
                                    _vm._v("审核通过"),
                                  ])
                                : _vm._e(),
                              item.status == 3
                                ? _c("span", { staticClass: "danger" }, [
                                    _vm._v("已驳回"),
                                  ])
                                : _vm._e(),
                            ]),
                            _c("div", [
                              _vm._v("提交时间：" + _vm._s(item.submitTime)),
                            ]),
                          ]
                        )
                      : _vm._e(),
                  ])
                }),
                0
              ),
            ]
          : _vm._e(),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }